import { Grid, styled } from "@mui/material";
import { THEME } from "../../../../config";

const DialogGridIcon = styled(Grid)(() => ({
    textAlign: "right",
    fontSize: "1.2rem",
    color: THEME.palette.primary.main
}));

export default DialogGridIcon